import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const TomatisSinContestar = ({ centro, q }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/patients", { params: { pendiente: "oido_sin_contestar", centro, q } }).then((r) => setRows(r.data));
  }, [centro, q]);
  return (
    <div className="bg-white border border-slate-200 rounded-lg" data-testid="tomatis-sin-contestar">
      {rows === null && <div className="p-6 text-center text-slate-400">Cargando…</div>}
      {rows?.length === 0 && <div className="p-6 text-center text-slate-400" data-testid="tomatis-sin-contestar-empty">Nadie pendiente de contestar a Tomatis.</div>}
      <div className="divide-y divide-slate-100">
        {rows?.map((p) => (
          <Link key={p.id} to={`/pacientes/${p.id}`} data-testid={`tomatis-sc-${p.id}`} className="flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-slate-50">
            <span className="flex-1 font-medium text-slate-900">{p.nombre}</span>
            <span className="text-xs text-slate-500">{p.centro}</span>
            <span className="w-28 text-xs text-slate-500">{p.telefono || "sin teléfono"}</span>
            <span className="rounded bg-amber-50 px-2 py-0.5 text-[11px] text-amber-800">Respuesta oído: sin contestar</span>
          </Link>
        ))}
      </div>
    </div>
  );
};
